/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export enum GpsMonitorisationModel {
  ACTIVE = 'Activ',
  INACTIVE = 'Inactiv'
}
